document.addEventListener("DOMContentLoaded", () => {
    const burger = document.querySelector(".burger");
    const mobileCategory = document.querySelector(".mobile-category");
    const mobileCategoryList = document.querySelector(".mobile-category-list");
    const modalClose = document.querySelector(".modal-close");
    const shopLinks = document.querySelectorAll(".shop-link");
    const subcategories = document.querySelectorAll(".subcategory");
    const backButtons = document.querySelectorAll(".back-button");

    // 햄버거 버튼 클릭 시 모달 열기
    document.addEventListener("click", (event) => {
    if (event.target.classList.contains("burger")) {
        mobileCategory.classList.add("active");
    }
});

    // 닫기 버튼 클릭 시 모달 닫기
    modalClose.addEventListener("click", () => {
        mobileCategory.classList.remove("active");
        subcategories.forEach(sub => sub.classList.remove("active"));
        mobileCategoryList.classList.remove("hide");
    });

    // "Shop" 링크 클릭 시 해당 서브 카테고리 열기
    shopLinks.forEach(link => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            const category = link.dataset.category;
            const subcategory = document.querySelector(`.subcategory[data-subcategory="${category}"]`);
            if (subcategory) {
                subcategory.classList.add("active");
                mobileCategoryList.classList.add("hide");
            }
        });
    });

    // 뒤로가기 버튼 클릭 시 서브 카테고리 닫기
    backButtons.forEach(button => {
        button.addEventListener("click", () => {
            button.closest(".subcategory").classList.remove("active");
            mobileCategoryList.classList.remove("hide");
        });
    });

    // 바깥을 클릭했을 때 모달 닫기 (선택 사항)
    window.addEventListener("click", (event) => {
        if (event.target === mobileCategory) {
            mobileCategory.classList.remove("active");
            subcategories.forEach(sub => sub.classList.remove("active"));
            mobileCategoryList.classList.remove("hide");
        }
    });
});